<template>
  <div class="i-base-animated-slider">
    <div
      class="slider-container"
      :class="props.slidingDirection"
      :style="{ animationDuration: props.animationDurationSecs + 's' }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  slidingDirection: {
    type: String,
    default: "left",
    validator(value: string) {
      return ["left", "right"].includes(value)
    }
  },
  animationDurationSecs: {
    type: String,
    default: "30"
  }
})
</script>

<style scoped lang="scss">
.slider-container {
  overflow: hidden;
  width: fit-content;
}

.left {
  animation-name: left;
}

.right {
  animation-name: right;
}

.left,
.right {
  animation-duration: 30s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes left {
  0% {
    transform: translateX(-10%);
  }

  100% {
    transform: translateX(-60%);
  }
}

@keyframes right {
  0% {
    transform: translateX(-60%);
  }

  100% {
    transform: translateX(-10%);
  }
}
</style>
